import React, { useEffect } from "react";
// import { useMemo } from "react";
// import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
// import { Line } from "react-chartjs-2";
// import { useState } from "react";
import placeImage from "../images/placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import { fetchSlider } from "../redux/slice/slider";
// import axios from "axios";
// import config from "../config";
// import NumberFormatter from "./NumberFormatter";

function HeroCarouselSkeleton() {
  return (
    <div className="intro-slider-skeleton" aria-busy="true" aria-label="Loading carousel">
      <div className="intro-slider-skeleton__image" />
      <div className="intro-slider-skeleton__dots">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

export default function HeroArea() {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1921 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1025 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 769 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  // const [filter, setFilter] = useState("weekly");
  // const [city, setCity] = useState("");
  // const [data, setData] = useState({
  //   location: [],
  //   price: [],
  //   lastUpdate: "",
  //   ingotprice: [],
  // });

  // const fetchIngot = useCallback(async () => {
  //   try {
  //     const response = await axios.get(`${config.apiUrl}/ingot-price`, {
  //       params: { ingot_price_type: filter, ingot_location: city },
  //     });
  //     setData({
  //       location: response.data.location,
  //       price: response.data.price,
  //       lastUpdate: response.data.last_update,
  //       ingotprice: response.data.latest_price,
  //     });
  //   } catch (error) {}
  // }, [filter, city]);

  // useEffect(() => {
  //   fetchIngot();
  // }, [fetchIngot]);

  // const chartData = useMemo(() => {
  //   if (!data.price.length) return { labels: [], datasets: [] };

  //   const labels =
  //     filter === "monthly"
  //       ? data.price.map((item) => item.day)
  //       : filter === "weekly"
  //       ? data.price.slice(-7).map((item) => item.day)
  //       : data.price.map((item) => item.time);

  //   const prices =
  //     filter === "weekly"
  //       ? data.price.slice(-7).map((item) => item.price)
  //       : data.price.map((item) => item.price);
  //   const colors =
  //     filter === "monthly"
  //       ? "rgb(255, 205, 86)"
  //       : filter === "weekly"
  //       ? "rgb(255, 99, 132)"
  //       : "rgb(75, 7, 201)";

  //   return {
  //     labels,
  //     datasets: [
  //       {
  //         label: `Last Updated: ${data.lastUpdate}`,
  //         backgroundColor: colors,
  //         borderColor: colors,
  //         data: prices,
  //       },
  //     ],
  //   };
  // }, [filter, data]);

  const dispatch = useDispatch();
  const { sliderData, isLoading, isError } = useSelector(
    (state) => state.slider
  );
  const showSkeleton =
    isLoading || (sliderData.length === 0 && !isError);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchSlider());
    }
  }, [dispatch, isError]);
  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  return (
    <>
      <div className="intro-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 slider-lg-padding">
              <div className="intro-slider-container">
                {showSkeleton ? (
                  <HeroCarouselSkeleton />
                ) : (
                  <Carousel
                    responsive={responsive}
                    swipeable={true}
                    draggable={true}
                    infinite={true}
                    showDots={true}
                    autoPlay={true}
                    autoPlaySpeed={4000}
                    removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                  >
                    {sliderData.map((sdata, index) => {
                      return (
                        <div className="intro-slider" key={index}>
                          <img
                            src={sdata.photo}
                            onError={imageOnError}
                            alt="slider"
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                )}
              </div>
            </div>
            {/* <div className="col-lg-5">
              <div className="ingot-updates">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <h6 className="text-primary">Ingot Price Updates</h6>
                    <div className="ingt-prc">
                      <h4 className="mb-0">
                        {data && data.ingotprice && (
                          <NumberFormatter number={data.ingotprice[0]} />
                        )}
                      </h4>
                      <p className="text-warning">
                        {data && data.ingotprice && (
                          <>
                            {data.ingotprice[0] - data.ingotprice[1] > 0 && "+"}
                            <NumberFormatter
                              number={data.ingotprice[0] - data.ingotprice[1]}
                            />
                          </>
                        )}
                      </p>
                    </div>
                    <span className="ingt-spn">
                      *Rates are based on average market price.
                    </span>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="ingt-fltr">
                      <div>
                        <select
                          value={filter}
                          onChange={(e) => setFilter(e.target.value)}
                        >
                          <option value="monthly">Last 30 Days</option>
                          <option value="weekly">Last 7 days</option>
                          <option value="daily">Today</option>
                        </select>
                      </div>
                      <div>
                        <Link
                          to="/historical-data"
                          className="hist-btn"
                          type="btn"
                        >
                          Hist Data
                          <i className="bi bi-chevron-double-right"></i>
                        </Link>
                      </div>
                      <div>
                        <select
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        >
                          {data.location.map((name, index) => {
                            return (
                              <option key={index} value={name}>
                                {name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="ingt-grph">
                      <Line data={chartData} />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
